import React from "react";

const HeaderTitle = (props) => {
  const { text } = props;

  return <span className="fs-26 tw:font-bold">{text}</span>;
};

export default HeaderTitle;
